// AvisoCar Design Tokens — RC-WEB-1 brand system (navy / blue / cyan).
// Green is NOT a brand accent anymore: it is reserved for semantic success.
export const brand = {
  navy: "#0B2545",
  navyDeep: "#071B2F",
  blue: "#1B84FF",
  blueHover: "#0F6FDB",
  cyan: "#5BC0FF",
  cyanSoft: "#E8F3FF",
};

export const colors = {
  // Primary gradient
  gradient: {
    from: "#071B2F",
    via: "#0F3D5C",
    to: "#0C2A44"
  },
  // Accent colors (brand blue)
  accent: {
    green: "#1B84FF",
    greenHover: "#0F6FDB",
    greenLight: "rgba(27, 132, 255, 0.2)"
  },
  // Background
  bg: {
    primary: "#0B2545",
    secondary: "#0F2942",
    card: "rgba(255, 255, 255, 0.1)",
    cardHover: "rgba(255, 255, 255, 0.15)"
  },
  // Text
  text: {
    primary: "#FFFFFF",
    secondary: "#94A3B8",
    muted: "#64748B"
  },
  // Status
  status: {
    active: "#10B981",
    pending: "#F59E0B",
    error: "#EF4444",
    info: "#3B82F6"
  }
};

// Protection type configurations
// iter65 — "contactos de emergencia" PURGADO por completo (el botón Emergencia del ESCÁNER sigue vivo vía push).

export const protectionTypes = {
  vehicle: {
    id: "vehicle",
    label: "Vehículo",
    emoji: "🚗",
    icon: "Car",
    description: "Protege tu auto, moto o cualquier vehículo",
    color: "from-blue-500 to-cyan-500",
    heroImage: "https://customer-assets.emergentagent.com/job_canva-stickers/artifacts/27dohpu7_image.png",
    fields: [
      { name: "name", label: "Nombre del vehículo", type: "text", placeholder: "Ej: Mi Auto Rojo", required: true },
      { name: "plate_number", label: "Placa (opcional)", type: "text", placeholder: "ABC-123", required: false }
    ]
  },
  kid: {
    id: "kid",
    label: "Niño",
    emoji: "🧒",
    icon: "Baby",
    description: "Protege a tus hijos en caso de extravío",
    color: "from-pink-500 to-rose-500",
    heroImage: "https://customer-assets.emergentagent.com/job_canva-stickers/artifacts/c93khhki_image.png",
    heroMessage: "Protege a tus hijos en caso de extravío o emergencia.",
    fields: [
      { name: "name", label: "Nombre del niño", type: "text", placeholder: "Ej: Sofía", required: true },
      { name: "age", label: "Edad (opcional)", type: "number", placeholder: "6", required: false },
      { name: "tutor_name", label: "Nombre de papá o mamá", type: "text", placeholder: "María García", required: true }
    ]
  },
  pet: {
    id: "pet",
    label: "Mascota",
    emoji: "🐶",
    icon: "Dog",
    description: "Protege a tu perro, gato o mascota",
    color: "from-amber-500 to-orange-500",
    heroImage: "https://customer-assets.emergentagent.com/job_canva-stickers/artifacts/1gtpg73k_image.png",
    fields: [
      { name: "name", label: "Nombre de la mascota", type: "text", placeholder: "Ej: Max", required: true },
      { name: "pet_type", label: "Tipo de mascota", type: "select", options: ["Perro", "Gato", "Otro"], required: true },
      { name: "vet_name", label: "Veterinario (opcional)", type: "text", placeholder: "Dr. García", required: false }
    ]
  },
  object: {
    id: "object",
    label: "Objeto",
    emoji: "🎒",
    icon: "Briefcase",
    description: "Protege maletas, mochilas, equipos",
    color: "from-purple-500 to-indigo-500",
    heroImage: "https://customer-assets.emergentagent.com/job_canva-stickers/artifacts/e8x4l7jy_image.png",
    fields: [
      { name: "object_type", label: "Tipo de objeto", type: "select", options: ["Maleta", "Mochila", "Billetera", "Laptop", "Otro"], required: true },
      { name: "name", label: "Nombre identificador", type: "text", placeholder: "Ej: Mi maleta negra", required: true }
    ]
  },
  other: {
    id: "other",
    label: "Otro",
    emoji: "⭐",
    icon: "Star",
    description: "Protege cualquier otra cosa importante",
    color: "from-teal-500 to-emerald-500",
    heroImage: "https://customer-assets.emergentagent.com/job_canva-stickers/artifacts/27dohpu7_image.png",
    fields: [
      { name: "name", label: "Nombre o descripción", type: "text", placeholder: "Ej: Silla de ruedas", required: true },
      { name: "description", label: "Descripción adicional", type: "textarea", placeholder: "Detalles importantes...", required: false }
    ]
  }
};

// Benefits list
export const benefits = [
  { icon: "Phone", text: "Llamadas privadas", description: "Tu número siempre oculto" },
  { icon: "Lock", text: "Tu número privado", description: "Nunca se muestra a quien escanea" },
  { icon: "Bell", text: "Avisos instantáneos", description: "Contacto en tiempo real" },
  { icon: "Shield", text: "Protección 24/7", description: "Activo siempre" }
];

// Stats icons mapping
export const statsConfig = [
  { key: "active_qrs", label: "QRs Activos", icon: "QrCode", color: "text-emerald-400" },
  { key: "emergencies", label: "Emergencias", icon: "AlertTriangle", color: "text-amber-400" },
  { key: "expiry_date", label: "Vencimiento", icon: "Calendar", color: "text-blue-400" },
  { key: "protection_type", label: "Protección", icon: "Shield", color: "text-purple-400" }
];
